import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import MapModeContent from './MapModeContent';
import GalleryModeContent from './GalleryModeContent';
import VideoModeContent from './VideoModeContent';
import ModelModeContent from './ModelModeContent';
import ResourceModeContent from './ResourceModeContent';
import StreamModeContent from './StreamModeContent';
import CustomerLogo from './../logo/CustomerLogo';
import messageManager from '../../../utilities/messageManager';
import loading from '../../../utilities/loading';
import { translate } from "react-i18next";

const RightPanelContentStyled = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const LogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const PanelContent = styled.div`
    overflow-y: auto;
    flex: 2;
    display: flex;
`;

export class RightPanelContent extends React.Component<Props, State> {
    constructor() {
        super();
        this.state = {
            logo: null,
        }
    }

    componentDidMount() {
        this.getLogo();
    }

    getLogo() {
        const { BASE_URL, axiosInstance, chosenProject } = this.props;
        loading.start();
        axiosInstance.get(`${BASE_URL}customers/${chosenProject.customerId}/logotype`)
            .then((response) => { 
                this.setState({logo: response.data});
                loading.stop();
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: error,
                })
                loading.stop();
            })
    }

    render() {
        const { selected } = this.props;
        return (
            <RightPanelContentStyled>
                {this.state.logo !== null 
                    ? <LogoWrapper><CustomerLogo logo={this.state.logo} /></LogoWrapper>
                    : null
                }
                <PanelContent logoVisible={this.state.logo ? true : false}>
                    {
                        {
                            'default': (<MapModeContent />),
                            'gallery': (<GalleryModeContent />),
                            'video': (<VideoModeContent />),
                            'resource': (<ResourceModeContent />),
                            'model': (<ModelModeContent />),
                            'stream': (<StreamModeContent />)
                        }[selected]
                    }
                </PanelContent >
            </RightPanelContentStyled >
        );
    }
};

const mapStateToProps = state => ({
    selected: state.modules.get('selected'),
    axiosInstance: state.auth.get('axiosInstance'),
    chosenProject: state.auth.get('chosenProject'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(RightPanelContent));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/RightPanelContent.jsx